import { getResolvedRef as e } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { isArraySchema as t } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/helpers/has-complex-array-items.ts
var n = [
	"allOf",
	"oneOf",
	"anyOf"
], r = (e) => "type" in e && e.type ? Array.isArray(e.type) ? e.type.includes("object") : e.type === "object" : "properties" in e, i = (e) => "$ref" in e || "discriminator" in e || n.some((t) => t in e), a = (n) => {
	if (!t(n) || typeof n.items != "object") return !1;
	if ("$ref" in n.items) return !0;
	let a = e(n.items);
	return a ? r(a) || i(a) || t(a) : !1;
}, o = (n) => {
	if (!n || !t(n) || typeof n.items != "object") return !1;
	if ("$ref" in n.items) return !0;
	let o = e(n.items);
	return o ? i(o) || r(o) ? !0 : a(o) : !1;
};
//#endregion
export { o as hasComplexArrayItems };

//# sourceMappingURL=has-complex-array-items.js.map